import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";

export function TableLoader({
  rowDepth = 3,
  cellDepth = 10,
}: {
  rowDepth?: number;
  cellDepth?: number;
}) {
  return (
    <TableBody>
      {Array.from(Array(rowDepth).keys()).map((i) => (
        <TableRow key={i}>
          {Array.from(Array(cellDepth).keys()).map((itd) => (
            <TableCell key={itd} />
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}

export function ProfileLoader() {
  return (
    <div>
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Skeleton variant="circle" width={142} height={142} />
      </div>
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          display: "flex",
          justifyContent: "center",
          marginTop: 20,
        }}
      >
        <Skeleton variant="rect" width={350} height={400} />
      </div>
    </div>
  );
}
